import { Box, Button, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";

type WorkspaceFeatureLockedPanelProps = {
  title: string;
  description: string;
  /** Shown when user can express interest (no match yet). */
  primaryActionLabel?: string;
  onPrimaryAction?: () => void;
  /** Shown when match exists but payment pending. */
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
};

export default function WorkspaceFeatureLockedPanel({
  title,
  description,
  primaryActionLabel,
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
}: WorkspaceFeatureLockedPanelProps) {
  return (
    <Paper withBorder radius="lg" p="xl" maw={720} mx="auto" mt="md">
      <Stack align="center" gap="md">
        <ThemeIcon size={56} radius="xl" variant="light" color="primary">
          <IconLock size={28} />
        </ThemeIcon>
        <Text fw={600} fz="lg" ta="center">
          {title}
        </Text>
        <Text fz="sm" c="slate.6" ta="center" maw={480}>
          {description}
        </Text>
        <Box>
          {primaryActionLabel && onPrimaryAction ? (
            <Button color="primary" onClick={onPrimaryAction}>
              {primaryActionLabel}
            </Button>
          ) : null}
          {secondaryActionLabel && onSecondaryAction ? (
            <Button variant="outline" color="primary" onClick={onSecondaryAction} mt={primaryActionLabel ? "sm" : 0}>
              {secondaryActionLabel}
            </Button>
          ) : null}
        </Box>
      </Stack>
    </Paper>
  );
}
